import React from 'react';
import classNames from 'classnames';

import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import { EmptyCart } from './sidebar/EmptyCart';
import UpsellBanner from '../containers/UpsellBanner';
import CommitmentUpsellBanner from '../containers/CommitmentUpsellBanner';
import LineItems from '../containers/LineItems';
import Ledger from './sidebar/Ledger';
import CheckoutButton from '../containers/CheckoutButton';
import { toggleScrollLock } from 'common/utils';
import { showHeaderOverlay, hideHeaderOverlay } from 'apps/application/header';
import { TranslatedMessage } from 'common/components/Intl';
import { Icon } from 'common/components/Icon';
import isEmpty from 'lodash/isEmpty';

export default class Sidebar extends React.Component {
  static propTypes = {
    isOpen: propTypes.bool.isRequired,
    currentOrder: accountPropTypes.OrderWithLineItems.isRequired,
    lineItemsProcessing: propTypes.array.isRequired,
    variants: propTypes.array.isRequired,
    shippingCost: propTypes.number.isRequired,
    totalSavings: propTypes.number.isRequired,
    lineItemsLength: propTypes.number.isRequired,
    mouseEnteredSidebar: propTypes.func.isRequired,
    mouseExitedSidebar: propTypes.func.isRequired,
    toggleVisibility: propTypes.func.isRequired,
    isSubscribableStore: propTypes.bool.isRequired,
    evergreenOffering: propTypes.object,
    cartCommitmentUpsellContent: propTypes.object,
  };

  componentDidMount() {
    this.props.fetchSplitTreatments && this.props.fetchSplitTreatments();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props.isOpen !== newProps.isOpen) {
      newProps.isOpen
        ? showHeaderOverlay({ isFullHeight: true })
        : hideHeaderOverlay();
      toggleScrollLock('.CartSidebar', newProps.isOpen);
    }
  }

  handleMouseEnter = () => {
    this.props.mouseEnteredSidebar();
  };

  handleMouseLeave = () => {
    this.props.mouseExitedSidebar();
  };

  renderCommitmentUpsellBanner = () => {
    const {
      isSubscribableStore,
      evergreenOffering,
      cartCommitmentUpsellContent,
    } = this.props;

    if (
      isSubscribableStore &&
      evergreenOffering &&
      evergreenOffering.commitmentReward &&
      !evergreenOffering.isSoldOut &&
      !isEmpty(cartCommitmentUpsellContent)
    ) {
      return (
        <CommitmentUpsellBanner
          evergreenOffering={evergreenOffering}
          {...cartCommitmentUpsellContent}
        />
      );
    }
  };

  render() {
    const {
      isOpen,
      currentOrder,
      shippingCost,
      totalSavings,
      lineItemsLength,
      isSubscribableStore,
    } = this.props;
    const isEmpty = lineItemsLength === 0;

    const rootClassNames = classNames('CartSidebar', {
      'CartSidebar--visible': isOpen,
      'CartSidebar--closed': !isOpen,
    });

    let content;
    if (isEmpty) {
      content = <EmptyCart onClickButton={this.props.toggleVisibility} />;
    } else {
      content = <LineItems />;
    }

    const subtotalCents = parseFloat(currentOrder.total_before_tax_fractional);
    const itemQuantity = currentOrder.total_quantity;
    const subTotalWithShipping =
      itemQuantity === 0 ? 0 : subtotalCents + shippingCost;

    return (
      <div
        className={rootClassNames}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className="CartSidebar__content">
          <div className="CartSidebar__header">
            <span className="heading--medium">
              <TranslatedMessage id={'cart.my_cart'} />
            </span>
            <Icon
              className="CartSidebar__close-icon"
              name="close"
              onClick={this.props.toggleVisibility}
            />
          </div>
          <div className="CartSidebar__banner--top">
            <UpsellBanner
              subtotalCents={subtotalCents}
              isSubscribableStore={isSubscribableStore}
            />

            {this.renderCommitmentUpsellBanner()}

            {this.renderErrorBanner()}
          </div>

          {content}

          <Ledger
            checkoutButton={<CheckoutButton />}
            savings={totalSavings}
            shipping={shippingCost}
            showTaxes={gon.current_store.preferences.show_taxes}
            showShipping={gon.current_store.preferences.show_shipping}
            subtotal={subtotalCents}
            total={subTotalWithShipping}
          />
        </div>
      </div>
    );
  }

  renderErrorBanner = () => {
    const { violations } = this.props.currentOrder;
    if (violations.length > 0) {
      const violation = violations[0];
      return (
        <div className="CartSidebar__banner--error intl-text">{violation}</div>
      );
    }
  };
}
